/**
 * Unified surface calculator for product page and quick-add drawer.
 * Replaces calc-js.liquid and calc-js-drawer.liquid.
 *
 * Usage:
 *   Product page: window.initCalculator(sectionId)
 *   Drawer: auto-init via MutationObserver on quick-add-drawer
 */
(function () {
  function initCalculator(sectionId) {
    var root = document;
    var $ = function (sel) { return root.querySelector(sel); };

    var sqmEl = $('#info__calc-' + sectionId + ' #sqmPerBox');
    if (!sqmEl) return; // No calculator for this product

    // Guard: don't re-init if already initialized (MutationObserver fires on variant change)
    if (sqmEl.dataset.calcInit) return;
    sqmEl.dataset.calcInit = 'true';

    var sqmPerBox = parseFloat(sqmEl.value);
    var weightEl = $('#info__calc-' + sectionId + ' #currentVariantWeight');
    var variantWeight = weightEl ? parseFloat(weightEl.value) : 0;

    var number = $('#calc-' + sectionId + ' input[data-area="sqm"]');
    var quantity = $('#info__calc-' + sectionId + ' input[name="quantity"]');
    var minus = $('#info__calc-' + sectionId + ' .btn--minus');
    var plus = $('#info__calc-' + sectionId + ' .btn--plus');
    var tenPercent = $('#check-' + sectionId + ' #tenPercent');
    var label = $('#check-' + sectionId + ' label');
    var addToCart = $('#add-' + sectionId + ' button[type="submit"]');
    var container = $('#info__calc-' + sectionId);
    var calcDiv = $('#calc-' + sectionId);
    var check = $('#check-' + sectionId);
    var properties = $('#props-' + sectionId);

    if (!number || !quantity || !tenPercent || !label || !properties) return;

    var propertiesHtml = properties.innerHTML;
    var txt = label.innerHTML;

    // Detect context by sectionId, not DOM (quick-add-drawer always exists in layout)
    var isDrawer = sectionId.indexOf('quickadd') !== -1;
    var stockPrefix = isDrawer ? '.quick-add-info__details' : '';
    var stock = $(stockPrefix + ' .delivery-stock') || $(stockPrefix + ' .stock');
    var stockVariant = $(stockPrefix + ' .delivery-stock-variant') || $(stockPrefix + ' .stock_variant');
    var inStock = $('.stock_available');
    var freeText = isDrawer
      ? $('.quick-add-info__details .freetext')
      : $('#info__price-' + sectionId + ' .freetext');
    var savings = isDrawer
      ? $('.quick-add-info__details .savings')
      : $('#info__price-' + sectionId + ' .savings');
    var priceM2 = isDrawer
      ? $('.quick-add-info__details .price_m2')
      : $('#info__price-' + sectionId + ' .price_m2');
    var space = isDrawer
      ? $('.quick-add-info__details .space')
      : $('#info__price-' + sectionId + ' .space');

    var stockAvailable = stock ? stock.dataset.availability : null;
    var stockVariantAvailable = stockVariant ? stockVariant.dataset.availability : null;

    var val, qty, qty2 = 1;

    // --- Surface input ---
    number.addEventListener('input', function (e) {
      e.preventDefault();
      tenPercent.checked = false;
      if (number.value == 0 || number.value == '') {
        quantity.value = 1;
        val = number.value;
        qty = quantity.value;
      } else {
        var value = parseInt(number.value);
        var required = Math.round((value / sqmPerBox) * 10) / 10;
        quantity.value = Math.ceil(required);
        val = number.value;
        qty = quantity.value;
      }
    });

    // --- Quantity input ---
    quantity.addEventListener('input', function () {
      var inputQty = parseInt(quantity.value);
      number.value = parseFloat(inputQty * sqmPerBox).toFixed(2);
      tenPercent.checked = false;
    });

    // --- Plus / Minus ---
    if (plus) plus.addEventListener('click', function () {
      var q = parseInt(quantity.value);
      number.value = parseFloat((q + 1) * sqmPerBox).toFixed(2);
      tenPercent.checked = false;
    });
    if (minus) minus.addEventListener('click', function () {
      var q = parseInt(quantity.value);
      if (q === 1) return;
      number.value = parseFloat((q - 1) * sqmPerBox).toFixed(2);
      tenPercent.checked = false;
    });

    // --- 10% waste checkbox ---
    tenPercent.addEventListener('click', function () {
      if (tenPercent.checked) {
        if (number.value == 0 || number.value == '') {
          val = number.value;
          qty = quantity.value;
          return;
        }
        val = number.value;
        qty = quantity.value;
        label.innerHTML = 'Enlever les 10% liés aux pertes de découpes';
        var percent = (parseFloat(number.value) * 10) / 100;
        var adjusted = (parseFloat(number.value) + percent).toFixed(2);
        number.value = parseFloat(adjusted);
        var required = Math.round((adjusted / sqmPerBox) * 10) / 10;
        quantity.value = Math.ceil(required);
      } else {
        number.value = val;
        quantity.value = qty;
        label.innerHTML = txt;
      }
    });

    // --- Échantillon toggle ---
    function setEchantillonMode(isEchantillon) {
      // Update paquet/échantillon label
      var paquetEl = document.querySelector('#info__price-' + sectionId + ' .paquet') || document.querySelector('.quick-add-info__details .paquet');
      if (paquetEl) paquetEl.textContent = isEchantillon ? ' / échantillon' : ' / paquet';

      var hideShow = function(el, hide) {
        if (!el) return;
        el.style.display = hide ? 'none' : '';
      };

      if (isEchantillon) {
        qty2 = quantity.value;
        hideShow(container, true);
        hideShow(calcDiv, true);
        hideShow(check, true);
        if (savings) savings.classList.add('hidden');
        if (priceM2) priceM2.classList.add('hidden');
        if (space) space.classList.add('hidden');
        if (stock) stock.classList.add('hidden');
        if (stockVariant) {
          if (!isDrawer && stockVariantAvailable === 'true') {
            stockVariant.classList.remove('hidden');
            if (inStock) inStock.classList.remove('hidden');
          } else if (isDrawer) {
            stockVariant.classList.remove('hidden');
          } else {
            if (inStock) inStock.classList.add('hidden');
          }
        }
        if (freeText) freeText.classList.remove('hidden');
        quantity.value = 1;
        properties.innerHTML = '';
      } else {
        hideShow(container, false);
        hideShow(calcDiv, false);
        hideShow(check, false);
        if (savings) savings.classList.remove('hidden');
        if (priceM2) priceM2.classList.remove('hidden');
        if (space) space.classList.remove('hidden');
        if (stock) {
          if (!isDrawer && stockAvailable === 'true') {
            stock.classList.remove('hidden');
            if (inStock) inStock.classList.remove('hidden');
          } else if (isDrawer) {
            stock.classList.remove('hidden');
          } else {
            if (inStock) inStock.classList.add('hidden');
          }
        }
        if (stockVariant) stockVariant.classList.add('hidden');
        if (freeText) freeText.classList.add('hidden');
        quantity.value = qty2;
        properties.innerHTML = propertiesHtml;
      }
    }

    var optLabels = document.querySelectorAll('.opt-label--btn');
    var echantillonChecked = false;
    optLabels.forEach(function (lbl) {
      var input = lbl.previousElementSibling;
      if (!input) return;
      var isEch = input.checked && (input.value.includes('échantillon') || input.value.includes('echantillon'));
      if (isEch) { echantillonChecked = true; setEchantillonMode(true); }
    });

    // Init: if default variant is carrelage (not échantillon), show stock
    if (!echantillonChecked) setEchantillonMode(false);

    // Event delegation for échantillon toggle — survives re-renders in drawer
    var delegateRoot = isDrawer ? document.querySelector('quick-add-drawer') : document;
    delegateRoot.addEventListener('click', function (e) {
      var lbl = e.target.closest('.opt-label--btn');
      if (!lbl) return;
      // Scope: ignore clicks from drawer when handling product page, and vice versa
      var inDrawer = !!lbl.closest('quick-add-drawer');
      if (isDrawer !== inDrawer) return;
      var input = lbl.previousElementSibling;
      if (!input) return;
      var isEch = input.value.includes('échantillon') || input.value.includes('echantillon');
      setEchantillonMode(isEch);
    });

    // --- Add to cart: inject surface + weight ---
    if (addToCart) addToCart.addEventListener('click', function () {
      if (properties.innerHTML !== '') {
        var surfaceEl = $('#props-' + sectionId + ' #surface');
        var weightEl2 = $('#props-' + sectionId + ' #poids');
        if (surfaceEl) surfaceEl.value = parseFloat(quantity.value * sqmPerBox).toFixed(2);
        if (weightEl2) weightEl2.value = ((variantWeight / 1000) * quantity.value).toFixed(2);
      }
    });
  }

  // Expose globally (guard against double execution)
  if (window.initCalculator) return;
  window.initCalculator = initCalculator;

  // --- Auto-init for quick-add drawer via MutationObserver ---
  document.addEventListener('DOMContentLoaded', function () {
    var drawerForm = document.querySelector('quick-add-drawer product-form');
    if (!drawerForm) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList') {
          var idEl = mutations[i].target.querySelector('[id^="sectionID-"]');
          if (idEl) {
            initCalculator(idEl.value);
          }
        }
      }
    });
    observer.observe(drawerForm, { childList: true, subtree: true });
  });
})();